<template>
    <div>
        <a v-if="index > 0" href="javascript:void(0)" @click="$emit('onMove','up')" style="margin-right: 10px"><span class="glyphicon glyphicon-arrow-up"></span></a>
        <a v-if="index < lastIndex" href="javascript:void(0)" @click="$emit('onMove','down')"><span class="glyphicon glyphicon-arrow-down"></span></a>
        &nbsp;
    </div>
</template>

<script>
    export default {
        props: ['index','max'],
        computed: {
            lastIndex: function(){
                return this.max - 1
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/MoveVertical.vue